import React, { useState } from 'react';
import iconImg1 from '../../../assets/icon-img01.png';
import { RiCloseFill } from 'react-icons/ri';

const SourcesTab = ({ data }) => {
  const [popOverInd, setPopOverInd] = useState(null);
  const handleOpen = ind => {
    document.body.classList.add('detail-active');
    setPopOverInd(ind);
  };

  const handleClose = e => {
    e.stopPropagation(); // prevent triggering parent click
    document.body.classList.remove('detail-active');
    setPopOverInd(null);
  };

  function trimString(str, length) {
    if (!str) return '';
    if (str.length <= length) return str;
    return str.slice(0, length) + '...';
  }
  return (
    <div>
      {data?.files?.length > 0 && <h3 className="block-heading">Attached source:</h3>}
      {data?.files?.map((elem, ind) => (
        <div className="content-box" onClick={() => handleOpen(ind)}>
          <div key={ind}>
            <div className="head">
              <div className="img-box">
                <img src={iconImg1} alt="img" />
              </div>
              <span className="text">Document</span>
            </div>
            <div className="text-box">
              <strong className="title">{elem?.title}</strong>
              <div className="document-description">
                {/* <p dangerouslySetInnerHTML={{ __html: elem?.snippet }} /> */}
                <p>{trimString(elem?.snippet, 200)}</p>
              </div>
            </div>
          </div>
          <div className="detail-holder">
            <div className="header">
              <strong className="title">{data?.files[popOverInd]?.title}</strong>
              <button className="btn-close" onClick={handleClose}>
                <RiCloseFill />
              </button>
            </div>
            <div className="text-area">{data?.files[popOverInd]?.snippet}</div>
          </div>
        </div>
      ))}
      {data?.source?.length > 0 && <h3 className="block-heading">Web source:</h3>}
      {data?.source?.map((elem, ind) => (
        <div className="content-box">
          <a href={elem?.url} key={ind} target="_blank">
            <div className="head">
              <div className="img-box">
                <img src={iconImg1} alt="img" />
              </div>
              <a className="text" href={elem?.url} target="_blank" rel="noopener noreferrer">
                {elem?.url}
              </a>
            </div>
            <div className="text-box">
              <strong className="title">{elem?.title}</strong>
              <p className="text-[var(--light-gray)]">{elem?.snippet}</p>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default SourcesTab;
